module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/135-belarus-e898e6fa09b91e43f62fee109fe8b673.svg";